App.factory('FeatureFlag', ['restmod', 'authService', (restmod, authService) => {
  return restmod.model('/feature_flags', {
    $hooks: {
      'before-request'(_req) {
        const locationId = authService.getLocationId()
        if (locationId) {
          _req.params = angular.extend(_req.params, { location_id: locationId })
        }
      }
    }
  })
}])
